import { Button, Stack } from '@mui/joy';
import { X } from '@phosphor-icons/react';
import { UseFieldArrayReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormField } from 'core/components';
import { InputType } from 'core/enums';
import { useFormContext } from 'core/states';
import { corporateUserService } from 'corporate/services';
import { IPricingProfileAccessForm } from 'pricing/components';
import { Color, Direction, Variant } from 'theme/enums';

interface IProps {
  users: UseFieldArrayReturn<IPricingProfileAccessForm, 'users'>;
}

export const UsersField = ({ users }: IProps) => {
  const { t } = useTranslation();
  const { control, errors, setValue } = useFormContext();

  const onRemove = (index: number) => {
    if (users.fields.length === 1) {
      setValue('allUsers', true);
    }

    users.remove(index);
  };

  return (
    <>
      {users.fields.map((userField, index) => (
        <Stack key={userField.id} direction={Direction.ROW} spacing={1}>
          <FormField
            name={`users.${index}.user`}
            type={InputType.AUTOCOMPLETE}
            wrapperStyle={{ flex: 1 }}
            inputProps={{
              control,
              error: errors.users?.[index]?.user,
              placeholder: t('placeholderSelectUser'),
              getOptions: corporateUserService.getCorporateUsersAutocomplete,
              disableClearable: true,
            }}
          />
          <Button variant={Variant.PLAIN} color={Color.DANGER} onClick={() => onRemove(index)}>
            <X />
          </Button>
        </Stack>
      ))}
    </>
  );
};
